/**
 * Gulf Cup quick-buy: nation/size selection + size guide.
 * Uses MutationObserver so it works after quick-buy modal injects HTML
 * (scripts inside <template> often do not run).
 */
(function () {
  function same(a, b) {
    return String(a == null ? '' : a).trim().toLowerCase() === String(b == null ? '' : b).trim().toLowerCase();
  }

  function foldAr(s) {
    return String(s || '')
      .replace(/[\u064B-\u065F\u0670]/g, '')
      .replace(/[أإآا]/g, 'ا')
      .replace(/ى/g, 'ي')
      .replace(/ة/g, 'ه')
      .replace(/\s+/g, '')
      .toLowerCase();
  }

  function nationKey(s) {
    const t = String(s == null ? '' : s).trim();
    const low = t.toLowerCase();
    const ar = foldAr(t);
    if (ar.indexOf('كويت') !== -1 || low.indexOf('kuwait') !== -1) return 'kuwait';
    if (ar.indexOf('سعود') !== -1 || low === 'ksa' || low.indexOf('saudi') !== -1) return 'ksa';
    if (ar.indexOf('عمان') !== -1 || low.indexOf('oman') !== -1) return 'oman';
    if (ar.indexOf('بحرين') !== -1 || low.indexOf('bahrain') !== -1) return 'bahrain';
    if (ar.indexOf('امارات') !== -1 || low === 'uae' || low.indexOf('united arab') !== -1 || low.indexOf('emirates') !== -1) return 'uae';
    if (ar.indexOf('قطر') !== -1 || low.indexOf('qatar') !== -1) return 'qatar';
    return low;
  }

  function sameNation(a, b) {
    if (same(a, b)) return true;
    const ka = nationKey(a);
    const kb = nationKey(b);
    return !!(ka && kb && ka === kb);
  }

  function optionOf(v, idx) {
    if (!v || idx < 0) return null;
    if (v.options && v.options[idx] != null) return v.options[idx];
    return v['option' + (idx + 1)];
  }

  function initRoot(root) {
    if (!root || root.dataset.gcQbReady === '1') return;
    root.dataset.gcQbReady = '1';

    const jsonEl = root.querySelector('[data-gc-qb-json]');
    let CFG = { variants: [] };
    try {
      if (jsonEl) CFG = JSON.parse(jsonEl.textContent);
    } catch (e) {}

    const variants = CFG.variants || [];
    const selections = {};

    root.querySelectorAll('[data-gc-option]').forEach((field) => {
      const idx = Number(field.getAttribute('data-option-index') || 0);
      const checked = field.querySelector('[aria-checked="true"]');
      selections[idx] = checked ? checked.getAttribute('data-value') : null;
      if (!selections[idx]) {
        const first = field.querySelector('.gc-qb__chip:not([disabled]), .gc-qb__size');
        if (first) selections[idx] = first.getAttribute('data-value');
      }
    });

    function findVariant() {
      return (
        variants.find((v) => {
          return Object.keys(selections).every((idx) => {
            const want = selections[idx];
            if (want == null) return true;
            const got = optionOf(v, Number(idx));
            if (same(got, want)) return true;
            const field = root.querySelector('[data-gc-option][data-option-index="' + idx + '"]');
            if (field && field.getAttribute('data-is-size') === '0') return sameNation(got, want);
            return false;
          });
        }) || null
      );
    }

    function formEl() {
      const id = root.getAttribute('data-form-id');
      return (id && document.getElementById(id)) || root.closest('form') || document.querySelector('quick-buy-modal form[action*="/cart/add"]');
    }

    function sync() {
      const v = findVariant();
      const form = formEl();
      if (form && v) {
        const input = form.querySelector('input[name="id"]');
        if (input) {
          const nextId = String(v.id);
          if (input.value !== nextId) {
            input.value = nextId;
            input.disabled = !v.available;
            try {
              input.dispatchEvent(new Event('change', { bubbles: true }));
            } catch (e) {}
          } else {
            input.disabled = !v.available;
          }
        }
        form.querySelectorAll('[type="submit"], button[name="add"]').forEach((btn) => {
          btn.disabled = !v.available;
        });
      }

      const nationField = root.querySelector('[data-gc-option][data-is-size="0"]');
      if (nationField) {
        const chip = nationField.querySelector('.gc-qb__chip[aria-checked="true"]');
        const display = (chip && (chip.getAttribute('data-display') || chip.getAttribute('data-value'))) || '';
        const picked = nationField.querySelector('[data-gc-picked]');
        if (picked && picked.textContent !== display) picked.textContent = display;
        if (chip && chip.getAttribute('data-accent')) {
          root.style.setProperty('--gc-accent', chip.getAttribute('data-accent'));
        }
        const value = (chip && chip.getAttribute('data-value')) || display;
        const nationKey = String(value || display).toLowerCase().trim();
        if (root.getAttribute('data-selected-nation') !== nationKey) {
          root.setAttribute('data-selected-nation', nationKey);
          try {
            root.dispatchEvent(
              new CustomEvent('gc-qb:nation', {
                bubbles: true,
                detail: { nation: display, value: value },
              })
            );
          } catch (e) {}
        }
      }

      const sizeField = root.querySelector('[data-gc-option][data-is-size="1"]');
      const nationIdx = nationField ? Number(nationField.getAttribute('data-option-index') || 0) : 0;
      const sizeIdx = sizeField ? Number(sizeField.getAttribute('data-option-index') || 1) : 1;
      const nationVal = selections[nationIdx];
      if (sizeField && nationVal != null) {
        sizeField.querySelectorAll('.gc-qb__size').forEach((btn) => {
          const s = btn.getAttribute('data-value');
          const match = variants.find((v) => sameNation(optionOf(v, nationIdx), nationVal) && same(optionOf(v, sizeIdx), s));
          const avail = !!(match && match.available);
          btn.classList.toggle('is-unavailable', !match || !avail);
          btn.hidden = !match;
        });
        const current = selections[sizeIdx];
        const visible = [...sizeField.querySelectorAll('.gc-qb__size')].filter((b) => !b.hidden);
        if (!visible.some((b) => same(b.getAttribute('data-value'), current)) && visible[0]) {
          selections[sizeIdx] = visible[0].getAttribute('data-value');
          visible.forEach((b) =>
            b.setAttribute('aria-checked', same(b.getAttribute('data-value'), selections[sizeIdx]) ? 'true' : 'false')
          );
          const v2 = findVariant();
          if (form && v2) {
            const input = form.querySelector('input[name="id"]');
            if (input && input.value !== String(v2.id)) {
              input.value = String(v2.id);
              input.disabled = !v2.available;
            }
          }
        }
      }
    }

    function paintChecked() {
      root.querySelectorAll('[data-gc-option]').forEach((field) => {
        const idx = Number(field.getAttribute('data-option-index') || 0);
        field.querySelectorAll('[data-value]').forEach((btn) => {
          btn.setAttribute('aria-checked', same(btn.getAttribute('data-value'), selections[idx]) ? 'true' : 'false');
        });
      });
      sync();
    }

    root.addEventListener('click', (e) => {
      const guide = e.target.closest('[data-gc-size-guide]');
      if (guide && root.contains(guide)) {
        e.preventDefault();
        const modal = root.closest('quick-buy-modal, .quick-buy-modal') || document;
        const drawer = modal.querySelector('.size-drawer-container');
        const backdrop = modal.querySelector('.size-drawer-backdrop');
        if (drawer && backdrop) {
          drawer.classList.add('is-open');
          backdrop.classList.add('is-open');
          document.body.style.overflow = 'hidden';
        }
        return;
      }

      const btn = e.target.closest('[data-value]');
      if (!btn || !root.contains(btn) || btn.disabled) return;
      const field = btn.closest('[data-gc-option]');
      if (!field) return;
      const idx = Number(field.getAttribute('data-option-index') || 0);
      selections[idx] = btn.getAttribute('data-value');
      paintChecked();
    });

    paintChecked();
  }

  function scan(node) {
    if (!node) return;
    if (node.matches && node.matches('[data-gc-qb]')) initRoot(node);
    if (node.querySelectorAll) node.querySelectorAll('[data-gc-qb]').forEach(initRoot);
  }

  scan(document);
  const mo = new MutationObserver((mutations) => {
    mutations.forEach((m) => {
      m.addedNodes.forEach((n) => {
        if (n.nodeType === 1) scan(n);
      });
    });
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();
